const bible = require('./voiceJobs.json');
const legacySermon = require('./sermonVoiceJob.json');
const addedSermons = require('./sermonVoiceJobs.json');
const sermons = [addedSermons.find(job => job.slug === legacySermon.slug) || legacySermon,
  ...addedSermons.filter(job => job.slug !== legacySermon.slug)];
module.exports = [
  ...bible.map(job => ({ ...job, kind: 'bible', title: `【案件】エゼキエル書 ${job.label} 声優募集`, path: `/jobs/ezekiel/${job.slug}`, imageKey: `ezekiel-${job.slug}`, sourcePath: `/bible/ezekiel/${job.chapter}/1?type=norm` })),
  ...sermons.map(sermon => ({ ...sermon, kind: 'sermon', title: `【案件】説教「${sermon.label}」声優募集`, path: `/jobs/sermon/${sermon.slug}`, imageKey: sermon.slug, sourcePath: `/sermon/${sermon.slug}` })),
];
